module.exports = __webpack_public_path__ + "static/img/to_submit.c73c9ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/to_submit.png
// module id = ff009e9c91d2990b
// module chunks = 59